import React, { useEffect, useRef, useState } from "react";
import { Grid, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";

import { stageDetailsAPICall } from "./APICallsAccountClosure";
import BankStyles from "../../pages/Finupdate/BankDetails.module.scss";
import { browserName } from "react-device-detect";
import { getCookie } from "../Finupdate/cookies";
import routesData from "../../shared/routes.json";
import BackDrop from "../../Components/BackDrop";
import keyboardicon from "../../Components/assets/Images/panicongrey.svg";
import {
  GetProfileDetailsCommonAPICall,
  LocationCheckAPICall,
  SaveIpAddressAPICall,
} from "../../shared/APICalls";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import axios from "axios";

export default function AccountClosureProfile() {
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);

  const [backgroundLoading, setBackgroundLoading] = useState(false);
  const [userData, setUserData] = useState({
    message: "",
    clientCode: "",
    fullName: "",
    email: "",
    mobile: "",
    pan: "",
    TradingPreference: "",
    isCompleted: false,
    dp_id: "",
  });
  const [tradingPreference, setTradingPreference] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [nextStage, setNextStage] = useState("");
  const [IPAddress, setIPAddress] = useState("");

  useEffect(() => {
    GetProfileDetails();
    StageDetails();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ"
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      LocationCheckAPICall(IPAddress?.trim())
        .then((response: any) => {
          if (response.data.data) {
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {
          setErrorMessage("latitude and longitude not found");
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        });
    }
  }, [IPAddress]);

  const GetProfileDetails = () => {
    GetProfileDetailsCommonAPICall()
      .then((response: any) => {
        const TP = response.data.data.TradingPreference;

        const filteredData = Object.keys(TP).filter((key) => TP[key] === true);

        const newData: any = filteredData.map((a) => {
          if (a.includes("equity")) {
            return "Equity";
          } else if (a.includes("futures_and_options")) {
            return "Futures and Options";
          } else if (a.includes("mutual_funds")) {
            return "Mutual Funds";
          }
        });

        const uniqueArray = newData.filter(
          (value: any, index: any) => newData.indexOf(value) === index
        );
        // console.log("TP", uniqueArray);
        setTradingPreference(uniqueArray);

        if (response.data?.data) {
          setUserData(response.data.data);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  const StageDetails = () => {
    let obj: any = {
      stage: "dashboard",
      request_id: null,
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        sessionStorage.setItem("acrequestID", response.data.data.request_id);
        setNextStage(response.data.data.next_stage);
        if (response.data.data.ErrMessage) {
          setErrorMessage(response.data.data.ErrMessage);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
  };

  const SaveIpAddress = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("acrequestID"),
      update_component: "account_closure",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("latitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {
        navigate(`/account_closure/${nextStage}`);
      })
      .catch((error: any) => {});
  };

  const handleNext = () => {
    SaveIpAddress();
  };

  return (
    <div className={BankStyles.mainWrapper}>
      <ErrorSnackBar message={errorMessage} />
      <div className={BankStyles.wrapper}>
        <div className={BankStyles.step}>
          <img src={keyboardicon} /> Step 1 of 4
        </div>
        <div className={BankStyles.HeaderSection}>
          <p className={BankStyles.Header}> Profile Details</p>
        </div>
        <p className={BankStyles.subText}>Confirm your profile information</p>
        {backgroundLoading && <BackDrop />}
        <div className={BankStyles.txtwrapper}>
          <Grid
            container
            rowSpacing={4}
            columnSpacing={{ xs: 1, sm: 2, md: 5 }}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Client Code"
                variant="outlined"
                name="fatherFullName"
                value={userData.clientCode}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Full Name"
                variant="outlined"
                name="fatherFullName"
                value={userData.fullName}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Email"
                variant="outlined"
                name="fatherFullName"
                value={userData.email}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Mobile"
                variant="outlined"
                name="fatherFullName"
                value={userData.mobile}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="PAN"
                variant="outlined"
                name="fatherFullName"
                value={userData.pan}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Trading Preference"
                variant="outlined"
                name="fatherFullName"
                value={
                  tradingPreference?.length > 0
                    ? tradingPreference.join(", ")
                    : "-"
                }
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="DP ID"
                variant="outlined"
                name="fatherFullName"
                value={userData.dp_id}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className={BankStyles.buttonStack}>
          <LoadingButton
            loading={loading}
            variant="contained"
            type="submit"
            id="linkUsingIFSCContinueButton"
            className={BankStyles.approveButton}
            sx={{
              height: "50px",
            }}
            onClick={handleNext}
          >
            Continue
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}
